import { createRoot } from "react-dom/client";
import { AuthMachineProvider } from "./lib/auth-machine";
import { ConvexErrorBoundary } from "./components/convex-error-boundary";
import { SessionKeyedConvexProvider } from "./lib/session-keyed-convex";
import App from "./App";
import "./index.css";

// Global error handler to capture TDZ and other errors with full stack traces
// This fires before React's error boundary and captures the precise JS stack
window.onerror = (message, source, lineno, colno, error) => {
  console.error("[GlobalErrorHandler]", {
    message,
    source,
    line: lineno,
    column: colno,
    stack: error?.stack,
  });
};

const CONVEX_URL = import.meta.env.VITE_CONVEX_URL;

if (!CONVEX_URL) {
  console.error("[App] VITE_CONVEX_URL is not set — Convex features will not work");
}

createRoot(document.getElementById("root")!).render(
  <AuthMachineProvider>
    <SessionKeyedConvexProvider>
      <ConvexErrorBoundary>
        <App />
      </ConvexErrorBoundary>
    </SessionKeyedConvexProvider>
  </AuthMachineProvider>,
);
